export default class AbonnementsApiDriveService {
  path = "/api/me/abonnements";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Liste des adresses LAD du client connecté
   */
  async abonnements() {
    const config = { ...this.httpApi.getConfig() };
    const res = await this.httpApi.get(this.path, config);
    return res.data;
  }
}
